import {createStore} from 'vuex'
import {MemberDataType} from "@/store/store.type";
import {EventType, OfferType, RewardType} from "@/store/store.event.type";
import {getLoginCookie, removeLoginCookie, setLoginCookie} from "@/utils/cookies";
import {getLoginRequiredData, route2Home} from "@/utils/general";

export enum CardEnum {
    BASIC, BLACK, GOLD, BEAUTY, TOURIST
}


export interface State {
    isLogin: boolean,
    fetchingData: boolean,
    memberData: MemberDataType[],
    card: CardEnum[],
    selectedType: number,
}

const getMemberDataIndex = (state: State, payload: (OfferType | RewardType)[]): number => {
    if (payload.length === 0) return -1;
    const memberClub = payload[0].MemberClub;
    return state.memberData.findIndex((d: MemberDataType) =>
        d?.ProfileDetails?.MemberClub === memberClub
    );
}

export default createStore<State>({
    state: {
        isLogin: false,
        memberData: [] as MemberDataType[],
        card: [],
        selectedType: 0,
        fetchingData: false,
    },
    mutations: {
        onAttemptLogin: (state) => {
            state.fetchingData = true;
            const loginKey = getLoginCookie();
            if (loginKey.length > 0) {
                getLoginRequiredData(loginKey).catch(() => {
                    route2Home();
                }).finally(() => {
                    state.fetchingData = false;
                });
            } else {
                state.fetchingData = false;
            }
        },
        onTypeChange: (state, payload: number) => {
            state.selectedType = payload;
        },
        onLogin: (state, payload: MemberDataType) => {
            state.isLogin = true;
            const memberClub = payload.ProfileDetails.MemberClub;
            const insertIndex = memberClub === 2 ? 0 : (memberClub === 3 ? 1 : 2);
            state.memberData[insertIndex] = payload;
            setLoginCookie({
                MemberClub: memberClub,
                MemberNo: payload.ProfileDetails.MemberNo,
                SessionKey: payload.SessionKey ?? '',
            });
        },
        onLogout: (state) => {
            state.isLogin = false;
            state.memberData = [];
            state.card = [];
            removeLoginCookie();
            route2Home();
        },
        updateReward: (state, payload: RewardType[]) => {
            const index = getMemberDataIndex(state, payload);
            if (index > -1) {
                state.memberData[index].rewards = payload;
            }
        },
        updatePrivilege: (state, payload: OfferType[]) => {
            const index = getMemberDataIndex(state, payload);
            if (index > -1) {
                state.memberData[index].privileges = payload;
            }
        },
        updateBDayOffer: (state, payload: OfferType[]) => {
            const index = getMemberDataIndex(state, payload);
            if (index > -1) {
                state.memberData[index].bDayOffer = payload;
            }
        },
        onDataFetching: (state, payload: boolean) => {
            state.fetchingData = payload;
        }
    },
    actions: {
        onAttemptLogin(context) {
            context.commit('onAttemptLogin');
        },
        onTypeChange(context) {
            context.commit('onTypeChange');
        },
        onLogin(context) {
            context.commit('onLogin');
        },
        onLogout(context) {
            context.commit('onLogout');
        },
        updateHappening(context) {
            context.commit('updateHappening')
        },
        updateReward(context) {
            context.commit('updateReward')
        },
        updatePrivilege(context) {
            context.commit('updatePrivilege')
        },
        updateBDayOffer(context) {
            context.commit('updateBDayOffer')
        },
        onDataFetching(context) {
            context.commit('onDataFetching')
        }
    },
    modules: {}
})
